function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_28518_33385)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.7049 50.6291C74.0164 83.334 53.6065 107.924 44.2623 117.76C41.8033 120.465 37.6229 120.219 35.4098 117.514C25.3279 106.203 1.22949 75.2192 1.22949 40.5471C1.22949 19.1537 18.9344 1.69465 40.5738 1.94055C49.1803 2.18646 57.2951 5.38318 63.4426 10.5471",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.5737 52.1043C82.389 52.1043 91.9672 42.5261 91.9672 30.7108C91.9672 18.8956 82.389 9.31738 70.5737 9.31738C58.7585 9.31738 49.1803 18.8956 49.1803 30.7108C49.1803 42.5261 58.7585 52.1043 70.5737 52.1043Z",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.9837 33.416L66.6394 39.0718",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.1639 25.793L66.6393 39.0717",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.3278 45.4652C53.3606 52.3505 47.2131 57.2685 39.836 57.2685C30.9836 57.2685 23.8524 50.1373 23.8524 41.2849C23.8524 32.4324 30.9836 25.3013 39.836 25.3013C43.5245 25.3013 46.7213 26.5308 49.4262 28.498",
  stroke: "#CCCCCC",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28518_33385"
}, /*#__PURE__*/React.createElement("rect", {
  width: 93.1967,
  height: 120,
  fill: "white",
  transform: "translate(0 0.710938)"
})));
function SvgIcnGeolocationAccessNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGeolocationAccessNeeded);
export default __webpack_public_path__ + "static/media/icn-geolocation-access-needed.3f7d9d96d0e55eed212060960da7c271.svg";
export { ForwardRef as ReactComponent };